/* Product family matrix (sections/product-family.liquid).
   Member list from the Convermax oew_style facet, details from each member's
   ?view=classifier JSON. Same data path the old Finish Options carousel used. */
(function () {
  var CM_SEARCH_URL = "https://oewholesale1.myconvermax.com/search.json";
  var VEHICLE_KEY = "cm_selected_vehicle";
  var PHONE_QUERY = "(max-width: 749px)";
  var DESKTOP_LIMIT = 15;
  var PHONE_LIMIT = 10;

  var CART_SVG =
    '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M2 3h2.2l2 10.5h9.6L18 6H5.2"/><circle cx="8" cy="16.5" r="1.3"/><circle cx="14.5" cy="16.5" r="1.3"/></svg>';

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // A query search highlights matches: "<b>DG21</b>-20110-...". Keep the text only.
  function plain(s) { return String(s == null ? "" : s).replace(/<[^>]*>/g, ""); }

  function facetUrl(style, withQuery, vehicle) {
    var url = new URL(CM_SEARCH_URL);
    if (withQuery) url.searchParams.set("query", style);
    url.searchParams.set("facet.0.field", "oew_style");
    url.searchParams.set("facet.0.selection", style);
    url.searchParams.set("pagesize", "50");
    if (vehicle) {
      url.searchParams.set("facet.1.field", "Year");
      url.searchParams.set("facet.1.selection", vehicle.year);
      url.searchParams.set("facet.2.field", "Make");
      url.searchParams.set("facet.2.selection", vehicle.make);
      url.searchParams.set("facet.3.field", "Model");
      url.searchParams.set("facet.3.selection", vehicle.model);
    }
    return url.toString();
  }

  /* PDP-16: with an empty query Convermax returns only part of a style (DG21: 3 of 8,
     so the product being viewed could be missing and never marked VIEWING). The same
     facet with the style as the query returns all of them. Ask both ways, merge by id. */
  function fetchMembers(style) {
    var get = function (u) { return fetch(u).then(function (r) { return r.json(); }).catch(function () { return {}; }); };
    return Promise.all([get(facetUrl(style, true)), get(facetUrl(style, false))]).then(function (res) {
      var seen = {}, items = [];
      res.forEach(function (d) {
        (d.Items || []).forEach(function (it) {
          var id = String(it.id);
          if (!seen[id]) { seen[id] = true; items.push(it); }
        });
      });
      return { Items: items };
    });
  }

  /* Nothing in the style fits this vehicle: Convermax still returns every item and
     tags the response Messages: ["IncompatibleParts"]. Those ids are not fits. */
  function hasIncompatible(data) {
    var msgs = data && data.Messages;
    if (!msgs || !msgs.length) return false;
    for (var i = 0; i < msgs.length; i++) {
      if (msgs[i] === "IncompatibleParts") return true;
    }
    return false;
  }

  /* Same with/without-query pair as the member list, plus Year/Make/Model.
     null means the call failed (show the table as if no vehicle were set). */
  function fetchFits(style, vehicle) {
    var get = function (u) {
      return fetch(u).then(function (r) {
        if (!r.ok) throw new Error("search failed");
        return r.json();
      }).catch(function () { return null; });
    };
    return Promise.all([get(facetUrl(style, true, vehicle)), get(facetUrl(style, false, vehicle))]).then(function (res) {
      if (!res[0] && !res[1]) return null;
      var ids = {};
      res.forEach(function (d) {
        if (!d || hasIncompatible(d)) return;
        (d.Items || []).forEach(function (it) { ids[String(it.id)] = true; });
      });
      return ids;
    });
  }

  function fetchClassifier(handle) {
    return fetch("/products/" + handle + "?view=classifier")
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function sizeKey(size) {
    // "20x11" -> [20, 11]; "22x9.5" -> [22, 9.5]
    var m = String(size || "").toLowerCase().split("x");
    return [parseFloat(m[0]) || 0, parseFloat(m[1]) || 0];
  }

  function diameterOf(size) {
    var d = sizeKey(size)[0];
    if (!d) return "";
    return String(Math.round(d * 100) / 100);
  }

  function stockCount(n) {
    if (n == null) return null;
    if (typeof n === "string" && n.trim() === "") return null;
    var num = typeof n === "number" ? n : parseFloat(n);
    return isNaN(num) ? null : num;
  }

  /* Hide only when both warehouses are out and the variant will not keep selling.
     A missing count is 0 only when the other count is missing too and available is
     false. Both counts missing while available is true stays visible. */
  function hiddenByStock(m) {
    if (m.current) return false;
    var fl = stockCount(m.fl);
    var tx = stockCount(m.tx);
    if (fl == null && tx == null) {
      if (m.rawAvailable !== false) return false;
      fl = 0;
      tx = 0;
    } else if (fl == null || tx == null) {
      return false;
    }
    if (m.policy === "continue") return false;
    return fl <= 0 && tx <= 0;
  }

  function stockCell(n) {
    var num = parseInt(n, 10);
    if (isNaN(num)) return '<div class="pf-stock is-unknown">&mdash;</div>';
    return '<div class="pf-stock ' + (num > 0 ? "is-in" : "is-out") + '"><span class="pf-dot"></span>' + num + "</div>";
  }

  function addToCart(variantId, quantity, button) {
    if (!window.routes || !window.fetchConfig || !window.miniCart) {
      window.location = "/cart/add?id=" + variantId + "&quantity=" + quantity;
      return;
    }
    button.disabled = true;
    var notice = window.cartStockNotice;
    var beforeQty = notice ? notice.quantityBefore(variantId) : null;
    if (notice) notice.clearNotice(button);
    var config = window.fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    config.body = JSON.stringify({
      id: variantId,
      quantity: quantity,
      sections: window.miniCart.getSectionsToRender().map(function (s) { return s.section; }),
      sections_url: window.location.pathname,
    });
    fetch(window.routes.cart_add_url, config)
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (!notice) { window.miniCart.updateSectionContents(); return; }
          return notice.settleSingle({
            body: res,
            variantId: variantId,
            requested: quantity,
            beforeQty: beforeQty,
            anchor: button,
            opener: button,
          });
        }
        if (notice) {
          notice.clearNotice(button);
          notice.fetchCart();
        }
        window.miniCart.renderContents(res);
        window.miniCart.open(button);
      })
      .catch(function () {})
      .finally(function () { button.disabled = false; });
  }

  function buildRow(m, ctx) {
    var row = document.createElement("div");
    row.className = "pf-row" + (m.current ? " is-current" : "");
    row.setAttribute("role", "row");
    row.dataset.finish = m.finish || "";
    row.dataset.diameter = m.diameter || "";
    row.dataset.id = m.id || "";
    if (m.current) row.dataset.current = "1";

    var html =
      '<div class="pf-cell-img">' + (m.image ? (m.current ? "" : '<a href="' + esc(m.url) + '" aria-label="' + esc(m.title) + '">') + '<img src="' + esc(m.image) + '" alt="' + esc(m.title) + '" loading="lazy" width="36" height="36">' + (m.current ? "" : "</a>") : "") + "</div>" +
      '<div class="pf-cell-size">' + (m.current ? esc(m.size) : '<a href="' + esc(m.url) + '">' + esc(m.size) + "</a>") + "</div>" +
      '<div>' + esc(m.offset) + "</div>" +
      '<div>' + esc(m.bolt) + "</div>" +
      '<div class="pf-cell-finish">' + esc(m.finish) + (m.current ? '<span class="pf-viewing">Viewing</span>' : "") + "</div>" +
      '<div class="pf-cell-sku">' + (m.current ? esc(m.sku) : '<a href="' + esc(m.url) + '">' + esc(m.sku) + "</a>") + "</div>" +
      (ctx.showUpc ? '<div class="pf-cell-upc">' + esc(m.upc) + "</div>" : "") +
      stockCell(m.fl) +
      stockCell(m.tx);

    if (ctx.loggedIn) {
      html +=
        '<div class="pf-cell-price"><span class="pf-price-wholesale">' + esc(m.priceText) + '</span>' + (m.retailText ? '<span class="pf-price-retail">' + esc(m.retailText) + "</span>" : "") + "</div>" +
        '<div class="pf-cell-qty"><div class="pf-qty"><button type="button" class="pf-qty-btn" data-minus aria-label="Decrease quantity">&minus;</button>' +
        '<input type="number" class="pf-qty-input" value="4" min="1" aria-label="Quantity"><button type="button" class="pf-qty-btn" data-plus aria-label="Increase quantity">&plus;</button></div></div>' +
        '<div class="pf-cell-add"><button type="button" class="pf-add" aria-label="Add to cart"' + (m.variantId && m.available ? "" : " disabled") + ">" + CART_SVG + "</button></div>";
    } else {
      html += '<div class="pf-cell-login" style="grid-column: span 3;"><a href="' + esc(ctx.loginUrl) + '" class="pf-login">Login for dealer pricing</a></div>';
    }
    row.innerHTML = html;

    if (ctx.loggedIn) {
      var input = row.querySelector(".pf-qty-input");
      row.querySelector("[data-minus]").addEventListener("click", function () {
        var v = parseInt(input.value, 10) || 1; if (v > 1) input.value = v - 1;
      });
      row.querySelector("[data-plus]").addEventListener("click", function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
      var add = row.querySelector(".pf-add");
      if (add && m.variantId) {
        add.addEventListener("click", function () { addToCart(m.variantId, parseInt(input.value, 10) || 1, add); });
      }
    }
    return row;
  }

  function loadVehicle() {
    try {
      var v = JSON.parse(localStorage.getItem(VEHICLE_KEY) || "null");
      if (v && v.year && v.make && v.model) return v;
    } catch (e) {}
    try {
      var raw = window.location.search.replace(/^\?/, "");
      if (!raw) return null;
      var seg = raw.split("/").map(decodeURIComponent), v2 = {};
      seg.forEach(function (s, i) {
        if (s === "Year") v2.year = seg[i + 1];
        if (s === "Make") v2.make = seg[i + 1];
        if (s === "Model") v2.model = seg[i + 1];
      });
      return v2.year && v2.make && v2.model ? v2 : null;
    } catch (e2) {
      return null;
    }
  }

  function validVehicle(v) {
    return v && v.year && v.make && v.model ? v : null;
  }

  function init(el) {
    if (el.dataset.pfInit) return;
    el.dataset.pfInit = "1";
    var style = el.dataset.style, productId = el.dataset.productId;
    if (!style || !productId) return;
    var state = { finish: "", diameter: "", fits: null, vehicle: null };
    var ready = false;
    var fitToken = 0;
    var userFiltered = false;
    var resizeTimer = 0;
    var wasPhone = window.matchMedia(PHONE_QUERY).matches;
    var ctx = {
      loggedIn: el.dataset.loggedIn === "1",
      loginUrl: el.dataset.loginUrl || "/account/login",
      showUpc: el.dataset.showUpc === "true",
      rows: el.querySelector("[data-pf-rows]"),
      wrap: el.querySelector(".pf-table-wrap"),
      head: el.querySelector(".pf-row-head"),
      finishWrap: el.querySelector("[data-pf-swatches]"),
      diameterWrap: el.querySelector("[data-pf-diameters]"),
      fit: el.querySelector("[data-pf-fit]"),
      none: el.querySelector("[data-pf-none]"),
      noneText: el.querySelector("[data-pf-none-text]"),
      showAll: el.querySelector("[data-pf-show-all]"),
      empty: el.querySelector("[data-pf-empty]"),
      fmt: new Intl.NumberFormat("en-US", { style: "currency", currency: el.dataset.currency || "USD" }),
    };

    function isPhone() { return window.matchMedia(PHONE_QUERY).matches; }

    function activeScroller() { return isPhone() ? ctx.rows : ctx.wrap; }

    function visibleRowEls() {
      var all = ctx.rows.querySelectorAll(".pf-row");
      var out = [];
      for (var i = 0; i < all.length; i++) if (!all[i].hidden) out.push(all[i]);
      return out;
    }

    function fitsOn() { return !!(state.vehicle && state.fits); }

    function rowWouldShow(row, finish, diameter) {
      if (finish && row.dataset.finish !== finish) return false;
      if (diameter && row.dataset.diameter !== diameter) return false;
      if (fitsOn() && row.dataset.current !== "1" && !state.fits[row.dataset.id]) return false;
      return true;
    }

    function fitTotal() {
      if (!state.fits) return 0;
      var n = 0;
      for (var k in state.fits) {
        if (Object.prototype.hasOwnProperty.call(state.fits, k) && state.fits[k]) n++;
      }
      return n;
    }

    function syncPills(container, selector, key) {
      if (!container) return;
      var pills = container.querySelectorAll(selector);
      for (var i = 0; i < pills.length; i++) {
        var b = pills[i];
        var value = b.dataset[key] || "";
        b.classList.toggle("is-active", value === (state[key] || ""));
        if (!value) {
          b.removeAttribute("aria-disabled");
          continue;
        }
        var finish = key === "finish" ? value : state.finish;
        var diameter = key === "diameter" ? value : state.diameter;
        var n = 0;
        var rows = ctx.rows.querySelectorAll(".pf-row");
        for (var r = 0; r < rows.length; r++) if (rowWouldShow(rows[r], finish, diameter)) n++;
        if (n === 0) b.setAttribute("aria-disabled", "true");
        else b.removeAttribute("aria-disabled");
      }
    }

    function vehicleLabel() {
      return state.vehicle.year + " " + state.vehicle.make + " " + state.vehicle.model;
    }

    function syncBanners(shown) {
      var active = fitsOn();
      var total = fitTotal();
      var some = active && total > 0;
      var none = active && total === 0;
      if (ctx.fit) {
        ctx.fit.hidden = !some;
        if (some) {
          ctx.fit.textContent = "";
          var mark = document.createElement("span");
          mark.className = "pf-fit-check";
          mark.setAttribute("aria-hidden", "true");
          ctx.fit.appendChild(mark);
          ctx.fit.appendChild(document.createTextNode("Showing wheels that fit your " + vehicleLabel()));
        }
      }
      if (ctx.none) {
        ctx.none.hidden = !none;
        if (none && ctx.noneText) {
          ctx.noneText.textContent = "None of the sizes in this style fit your " + vehicleLabel() + ".";
        }
      }
      if (ctx.empty) ctx.empty.hidden = shown !== 0;
    }

    function contentHeight(scroller, last) {
      var rect = scroller.getBoundingClientRect();
      var cs = window.getComputedStyle(scroller);
      var top = rect.top + (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.paddingTop) || 0);
      return Math.ceil(last.getBoundingClientRect().bottom - top);
    }

    function revealCurrent(scroller) {
      var rows = visibleRowEls();
      var limit = isPhone() ? PHONE_LIMIT : DESKTOP_LIMIT;
      var headerH = !isPhone() && ctx.head ? ctx.head.offsetHeight : 0;
      for (var i = 0; i < rows.length; i++) {
        if (!rows[i].classList.contains("is-current")) continue;
        if (i < limit) return;
        var delta = rows[i].getBoundingClientRect().top - scroller.getBoundingClientRect().top;
        scroller.scrollTop = Math.max(0, delta - headerH);
        return;
      }
    }

    function updateCap(mode) {
      var phone = isPhone();
      var scroller = phone ? ctx.rows : ctx.wrap;
      var other = phone ? ctx.wrap : ctx.rows;
      if (!scroller) return;
      var kept = mode === "keep" ? scroller.scrollTop : 0;
      if (other) {
        other.style.maxHeight = "";
        other.classList.remove("is-capped");
      }
      var rows = visibleRowEls();
      var limit = phone ? PHONE_LIMIT : DESKTOP_LIMIT;
      scroller.scrollTop = 0;
      scroller.style.maxHeight = "none";
      if (rows.length <= limit) {
        scroller.classList.remove("is-capped");
        scroller.style.maxHeight = "";
        return;
      }
      var height = contentHeight(scroller, rows[limit - 1]);
      if (height < 1) {
        scroller.classList.remove("is-capped");
        scroller.style.maxHeight = "";
        return;
      }
      scroller.classList.add("is-capped");
      scroller.style.maxHeight = height + "px";
      if (mode === "reveal") revealCurrent(scroller);
      else if (mode === "keep") scroller.scrollTop = kept;
      else scroller.scrollTop = 0;
    }

    function applyFilters(mode) {
      var rows = ctx.rows.querySelectorAll(".pf-row");
      var shown = 0;
      for (var i = 0; i < rows.length; i++) {
        var show = rowWouldShow(rows[i], state.finish, state.diameter);
        rows[i].hidden = !show;
        if (show) shown++;
      }
      syncPills(ctx.finishWrap, ".pf-swatch", "finish");
      syncPills(ctx.diameterWrap, ".pf-diameter", "diameter");
      syncBanners(shown);
      el.hidden = false;
      requestAnimationFrame(function () {
        var next = mode || "reset";
        updateCap(next);
        watchFonts(next);
      });
    }

    function runVehicle(vehicle, reveal) {
      state.vehicle = validVehicle(vehicle);
      var token = ++fitToken;
      if (!state.vehicle) {
        state.fits = null;
        if (ready) applyFilters(reveal ? "reveal" : "reset");
        return;
      }
      fetchFits(style, state.vehicle).then(function (fits) {
        if (token !== fitToken) return;
        state.fits = fits;
        if (ready) applyFilters(reveal ? "reveal" : "reset");
      });
    }

    function onPillClick(e, selector, key) {
      var b = e.target.closest(selector);
      if (!b || b.getAttribute("aria-disabled") === "true") return;
      userFiltered = true;
      state[key] = b.dataset[key] || "";
      applyFilters("reset");
    }

    if (ctx.finishWrap) {
      ctx.finishWrap.addEventListener("click", function (e) { onPillClick(e, ".pf-swatch", "finish"); });
    }
    if (ctx.diameterWrap) {
      ctx.diameterWrap.addEventListener("click", function (e) { onPillClick(e, ".pf-diameter", "diameter"); });
    }
    if (ctx.showAll) {
      ctx.showAll.addEventListener("click", function () {
        userFiltered = true;
        fitToken++;
        state.fits = null;
        applyFilters("reset");
      });
    }

    document.addEventListener("cm:vehicle-changed", function (event) {
      if (!ready) return;
      userFiltered = true;
      runVehicle(event.detail, false);
    });
    document.addEventListener("cm:vehicle-cleared", function () {
      if (!ready) return;
      userFiltered = true;
      runVehicle(null, false);
    });

    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!ready) return;
        var phone = isPhone();
        var mode = phone === wasPhone ? "keep" : "reset";
        wasPhone = phone;
        updateCap(mode);
      }, 150);
    });

    var watchedFonts = false;
    function watchFonts(mode) {
      if (watchedFonts) return;
      watchedFonts = true;
      var fonts = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
      fonts.then(function () {
        if (!ready || userFiltered) return;
        requestAnimationFrame(function () { updateCap(mode === "reveal" ? "reveal" : "keep"); });
      });
    }

    function buildSwatches(members) {
      var wrap = ctx.finishWrap;
      if (!wrap) return;
      var finishes = [];
      members.forEach(function (m) { if (m.finish && finishes.indexOf(m.finish) < 0) finishes.push(m.finish); });
      if (finishes.length < 2) return;
      var all = document.createElement("button");
      all.type = "button"; all.className = "pf-swatch is-active"; all.dataset.finish = ""; all.textContent = "All";
      wrap.appendChild(all);
      finishes.forEach(function (f) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "pf-swatch"; b.dataset.finish = f;
        var m = members.filter(function (x) { return x.finish === f; })[0];
        b.innerHTML = (m && m.image ? '<img src="' + esc(m.image) + '" alt="" width="22" height="22">' : '<span class="pf-swatch-dot"></span>') + esc(f);
        wrap.appendChild(b);
      });
    }

    function buildDiameters(members) {
      var wrap = ctx.diameterWrap;
      if (!wrap) return;
      var dias = [];
      members.forEach(function (m) { if (m.diameter && dias.indexOf(m.diameter) < 0) dias.push(m.diameter); });
      if (dias.length < 2) {
        wrap.hidden = true;
        return;
      }
      dias.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
      wrap.hidden = false;
      var all = document.createElement("button");
      all.type = "button"; all.className = "pf-diameter is-active"; all.dataset.diameter = ""; all.textContent = "All";
      wrap.appendChild(all);
      dias.forEach(function (d) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "pf-diameter"; b.dataset.diameter = d; b.textContent = d + '"';
        wrap.appendChild(b);
      });
    }

    fetchMembers(style)
      .then(function (data) {
        var items = data.Items || [];
        if (items.length < 2) return;
        return Promise.all(items.map(function (item) {
          return fetchClassifier(item.handle).then(function (c) {
            var specs = (c && c.specs) || {}, inv = (c && c.inventory) || {};
            return {
              id: String(item.id),
              current: String(item.id) === String(productId),
              url: item.url, image: item.image, sku: plain(item.sku), title: plain(item.title),
              variantId: item.variant_ids && item.variant_ids[0],
              // PDP-38: Convermax's price is the store's base price (MAP); the classifier is rendered
              // in the dealer's session, so its price is their own tier price.
              price: (c && typeof c.price === "number") ? c.price / 100 : item.price,
              priceText: (c && c.price_text) || ctx.fmt.format(item.price || 0),
              retailText: (c && c.retail_price) || "",
              upc: (c && c.barcode) || "",
              size: specs.size || "", bolt: specs.bolt_pattern || "", offset: specs.offset || "", finish: specs.finish || "",
              diameter: diameterOf(specs.size || ""),
              fl: inv.stock_florida, tx: inv.stock_texas,
              policy: inv.policy || "",
              rawAvailable: inv.available,
              available: inv.available !== false,
            };
          });
        }));
      })
      .then(function (members) {
        if (!members) return;
        members.sort(function (a, b) {
          var ka = sizeKey(a.size), kb = sizeKey(b.size);
          return ka[0] - kb[0] || ka[1] - kb[1] || String(a.finish).localeCompare(String(b.finish));
        });
        var visible = [];
        members.forEach(function (m) { if (!hiddenByStock(m)) visible.push(m); });
        if (!visible.length) return;
        visible.forEach(function (m) { ctx.rows.appendChild(buildRow(m, ctx)); });
        buildSwatches(visible);
        buildDiameters(visible);
        var sizes = [];
        visible.forEach(function (m) {
          var d = sizeKey(m.size)[0]; if (d && sizes.indexOf(d) < 0) sizes.push(d);
        });
        sizes.sort(function (a, b) { return a - b; });
        var sub = el.querySelector("[data-pf-sub]");
        if (sub) sub.textContent = visible.length + " SKUs · " + sizes.join(" & ") + " inch";
        ready = true;
        runVehicle(loadVehicle(), true);
      })
      .catch(function () {});
  }

  function boot() { document.querySelectorAll("[data-product-family]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
